var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUppticLogoSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0.014L14.226 0.014 14.226 15.814 0 15.814z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DA1BFF",
    d: "M14.57 8.527c-.098 0-.342-.028-.49-.288L9.92.898c-.148-.26-.05-.49 0-.576.049-.087.195-.288.49-.288h8.323c.294 0 .44.201.49.288.048.087.146.316 0 .576l-4.163 7.341c-.147.26-.391.288-.49.288",
    transform: "translate(2.4 3.361)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4 3.361) translate(0 .02)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9743EB",
    d: "M10.51 15.814c-.752 0-1.479-.224-2.1-.647-.353-.24-.607-.494-.756-.756L.103 1.166C-.189.655.173.014.754.014h4.508c1.44 0 2.8.777 3.55 2.028l5.07 9.178c.503.913.455 2.045-.144 2.896l-.013.018c-.746 1.052-1.948 1.68-3.215 1.68z",
    mask: "url(#prefix__b)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUppticLogoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upptic-logo-small.e03d887ff0a25e7e9500efb01c0f691d.svg";